export default __webpack_public_path__ + "static/char-s-18-kr-8caf9a33adac5d198ab7de4d41de86e6.png";